// extracted by mini-css-extract-plugin
module.exports = {"carFeatures":"CarFeatures_carFeatures__MPR_g","title":"CarFeatures_title__QkLqc","titleRow":"CarFeatures_titleRow__AnTmu","value":"CarFeatures_value__My3VC"};